module.exports = __webpack_public_path__ + "bef60edc51d22d94f2adb95c9e35c15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/s_logo.png
// module id = 555
// module chunks = 1